/// <reference types="vite/client" />
import { createClient } from "@supabase/supabase-js";

const url  = import.meta.env.VITE_SUPABASE_URL  as string;
const key  = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Disable navigator.locks — mencegah error "lock was stolen" saat buka 2 window bersamaan.
// Aman untuk internal tool (tidak ada race condition signup/OAuth yang perlu dilindungi).
export const supabase = createClient(url, key, {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  auth: { lock: ((_name: any, _acquireTimeout: any, fn: any) => fn()) as any },
});
